import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import {API} from '../../config/api';
import {GlobalFunction} from '../../common/core/global_function';
import * as moment from 'moment';

function createCommonCondition(academicYear: any, selectedSchoolList?, selectedMentor?, selected_mentee?, studentCode?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?): any {
  const condition = {};

  // Generate school
  if (selectedSchoolList && selectedSchoolList.length > 0 && !selectedSchoolList.includes('all')) {
    condition['school[in]'] = selectedSchoolList.join(',');
  }

  // Generate tiers
  // if (tiers && tiers.length > 0 && !tiers.includes('all')) {
  //   let hasIndividualContact = false;
  //   let hasIndividualMentoring = false;
  //   const validTiers = tiers.filter((tier: string) => {
  //     let isIndividualContact = tier === 'individual_contact';
  //     if (isIndividualContact) {
  //       hasIndividualContact = true;
  //     } else if (tier === 'individual_mentoring') {
  //       hasIndividualMentoring = true;
  //     }
  //     return !isIndividualContact;
  //   });

  //   if (hasIndividualContact && !hasIndividualMentoring) {
  //     validTiers.push('individual_mentoring');
  //     condition['group_setting[in]'] = 'individual_contact';
  //   } else if (!hasIndividualContact && hasIndividualMentoring) {
  //     condition['group_setting[nin]'] = 'individual_contact';
  //   }

  //   condition['tier_of_activity[in]'] = validTiers.join(',');
  // }

  // null value of individualContact means both yes and no.
  // same for individualMentoring
  let includeAllTiers = tiers.includes('all');
  let excludeTiers = [];
  let validTiers = tiers && tiers.length > 0 && !includeAllTiers ? tiers.slice() : [];
  if (individualContact == null && individualMentoring == null) {
    // both individualContact and individualMentoring are 'all'
    if (!includeAllTiers && validTiers.length > 0) {
      validTiers.push('individual_mentoring');
    }
  } else if (individualContact && individualMentoring) {
    // both individualContact and individualMentoring are 'yes'
    validTiers = ['individual_mentoring'];
    condition['sub_tier_of_activity'] = 'one_on_one_mentoring';
    condition['group_setting'] = 'individual_contact';
    condition['group_setting[ne]'] = 'individual_contact';
  } else if (individualContact === false && individualMentoring === false) {
    // both individualContact and individualMentoring are 'no'
    condition['sub_tier_of_activity[ne]'] = 'one_on_one_mentoring';
  } else if (individualContact == null && individualMentoring) {
    // individualContact is 'all', individualMentoring is 'yes'
    validTiers = ['individual_mentoring'];
    condition['sub_tier_of_activity'] = 'one_on_one_mentoring';
    condition['group_setting[ne]'] = 'individual_contact';
  } else if (individualContact == null && individualMentoring == false) {
    // individualContact is 'all', individualMentoring is 'no'
    if (!includeAllTiers && validTiers.length > 0) {
      validTiers.push('individual_mentoring');
    }
    condition['group_setting[in]'] = 'individual_contact';
  } else if (individualContact && individualMentoring == null) {
    // individualContact is 'yes', individualMentoring is 'all'
    validTiers = ['individual_mentoring'];
    condition['sub_tier_of_activity'] = 'one_on_one_mentoring';
    condition['group_setting'] = 'individual_contact';
  } else if (individualContact && individualMentoring == false) {
    // individualContact is 'yes', individualMentoring is 'no'
    validTiers = ['individual_mentoring'];
    condition['sub_tier_of_activity'] = 'one_on_one_mentoring';
    condition['group_setting'] = 'individual_contact';
  } else if (individualContact == false && individualMentoring == null) {
    /// individualContact is 'no', individualMentoring is 'all'
    if (!includeAllTiers && validTiers.length > 0) {
      validTiers.push('individual_mentoring');
    }
    condition['group_setting[ne]'] = 'individual_contact';
  } else if (individualContact == false && individualMentoring) {
    /// individualContact is 'no', individualMentoring is 'yes'
    validTiers = ['individual_mentoring'];
    condition['sub_tier_of_activity'] = 'one_on_one_mentoring';
    condition['group_setting[ne]'] = 'individual_contact';
  }
  if (validTiers.length > 0) {
    condition['tier_of_activity[in]'] = validTiers.join(',');
  }
  if (excludeTiers.length > 0) {
    condition['tier_of_activity[nin]'] = excludeTiers.join(',');
  }

  // Generate groups
  if (group && group.length > 0 && !group.includes('all')) {
    condition['group[in]'] = group.join(',');
  }

  if (contactMeans && contactMeans.length > 0 && !contactMeans.includes('all')) {
    condition['activity_contact_means[in]'] = contactMeans.join(',');
  }

  // Generate mentor
  if (selectedMentor && selectedMentor != 'all') condition['mentor'] = selectedMentor;
  if (classSize && classSize != 'all') condition['class_size'] = classSize;
  if (schoolSyllabus && schoolSyllabus != 'all') condition['school_syllabus'] = schoolSyllabus == 'yes';
  if (selected_mentee == 'mentee' || selected_mentee == 'non_mentee') condition['mentee'] = selected_mentee == 'mentee';
  if (studentCode) condition['student_code[in]'] = studentCode.replace(/\s/g, "");
  if (gender == 'M' || gender == 'F') condition['gender'] = gender;

  if (Array.isArray(academicYear)) {
    condition['academic_year[in]'] = academicYear.join();
  } else {
    condition['academic_year'] = academicYear;
  }
  condition['activity_date[null]'] = false;

  return condition;
}

@Injectable()
export class PortfolioService extends ServiceGlobal {

  getYearReportSummary(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'report_summary';
    return this._db.get(api, condition);
  }

  getYearAvgLabelGroup(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'year_report_details';
    return this._db.get(api, condition);
  }

  getYearAvgLabelGroupBeforeIc(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'year_report_details_before_individual_contact';
    return this._db.get(api, condition);
  }

  getYearAvgLabelGroupAfterIc(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'year_report_details_after_individual_contact';
    return this._db.get(api, condition);
  }

  getYearAvgLabelGroupBeforeFirstMentee(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'year_report_details_before_first_mentee';
    return this._db.get(api, condition);
  }

  getYearAvgLabelGroupAfterFirstMentee(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'year_report_details_after_first_mentee';
    return this._db.get(api, condition);
  }

  getYearReportLabelGroupDetails(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'report_label_group_details';
    return this._db.get(api, condition);
  }

  getYearReportLabelGroupDetailsBeforeIc(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'report_label_group_details_before_individual_contact';
    return this._db.get(api, condition);
  }

  getYearReportLabelGroupDetailsAfterIc(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'report_label_group_details_after_individual_contact';
    return this._db.get(api, condition);
  }

  getYearReportLabelGroupDetailsBeforeFirstMentee(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'report_label_group_details_before_first_mentee';
    return this._db.get(api, condition);
  }

  getYearReportLabelGroupDetailsAfterFirstMentee(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'report_label_group_details_after_first_mentee';
    return this._db.get(api, condition);
  }

  getYearChartReportSummary(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);
    let api = API.API_URL_COMMON + 'report_charts';

    return this._db.get(api, condition);
  }

  getMonthReportSummary(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, startDate?, endDate?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getConditionMonth(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, startDate, endDate, tiers, gender, group, classSize, contactMeans, schoolSyllabus, null, individualContact, individualMentoring);
    let api = API.API_URL_COMMON + 'month_report_summary';
    return this._db.get(api, condition);
  }

  getMonthAvgLabelGroup(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, startDate?, endDate?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, selectedOptionMonth?, individualContact?, individualMentoring?) {
    let condition = this.getConditionMonth(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, startDate, endDate, tiers, gender, group, classSize, contactMeans, schoolSyllabus, selectedOptionMonth, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'month_report_details';
    return this._db.get(api, condition);
  }

  getMonthReportLabelGroupDetails(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, startDate?, endDate?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, selectedOptionMonth?, individualContact?, individualMentoring?) {
    let condition = this.getConditionMonth(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, startDate, endDate, tiers, gender, group, classSize, contactMeans, schoolSyllabus, selectedOptionMonth, individualContact, individualMentoring);

    let api = API.API_URL_COMMON + 'month_report_label_group_details';
    return this._db.get(api, condition);
  }

  getMonthChartReportSummary(academicYear: any, selectedSchoolList? :any[], selectedMentor?: any, selected_mentee?: any, studentCode?: any, startDate?, endDate?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    let condition = this.getConditionMonth(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, startDate, endDate, tiers, gender, group, classSize, contactMeans, schoolSyllabus, null, individualContact, individualMentoring);
    let api = API.API_URL_COMMON + 'report_charts';

    return this._db.get(api, condition);
  }

  // Wait API report in n
  getCondition(academicYear: any, selectedSchoolList?, selectedMentor?, selected_mentee?, studentCode?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, individualContact?, individualMentoring?) {
    const condition = createCommonCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);
    this.getDefaultDateActivity(academicYear, condition);
    return condition;
  }

  // Wait API report in n
  getConditionMonth(academicYear: any, selectedSchoolList?, selectedMentor?, selected_mentee?, studentCode?, startDate?, endDate?, tiers?, gender?, group?, classSize?, contactMeans?, schoolSyllabus?, selectedOptionMonth?, individualContact?, individualMentoring?) {
    const condition = createCommonCondition(academicYear, selectedSchoolList, selectedMentor, selected_mentee, studentCode, tiers, gender, group, classSize, contactMeans, schoolSyllabus, individualContact, individualMentoring);

    if (!startDate) {
      this.getDefaultDateActivity(academicYear, condition);
    } else {
      this.getDateActivity(academicYear, condition, startDate, endDate);
    }

    if (selectedOptionMonth != null) {
      condition['option'] = selectedOptionMonth;
    }

    return condition;
  }

  getDefaultDateActivity(academicYear: any, condition: any = {}) {
    // assume GlobalFunction.getAcademicYears() has already been completed
    // at least once before using this function (completed mean the promise
    // returned by getAcademicYears() is resolved).
    const academicYearsMap = GlobalFunction['academic_years_obj'];
    if (Array.isArray(academicYear)) {
      const arrayCopy = academicYear.slice();
      arrayCopy.sort();
      const startAcademicYear = arrayCopy[0];
      const endAcademicYear = arrayCopy[arrayCopy.length - 1];
      const startAcademicYearObject = academicYearsMap[startAcademicYear];
      const endAcademicYearObject = academicYearsMap[endAcademicYear];
      condition['activity_date[gte]'] = startAcademicYearObject.from_time;
      condition['activity_date[lte]'] = endAcademicYearObject.to_time;
    } else {
      const academicYearObject = academicYearsMap[academicYear];
      condition['activity_date[gte]'] = academicYearObject.from_time;
      condition['activity_date[lte]'] = academicYearObject.to_time;
    }
  }

  getDateActivity(academicYear: any, condition: any = {}, startDate, endDate) {
    let start = moment(startDate).startOf('date');
    let end = moment(endDate).endOf('date');
    condition['activity_date[gte]'] = start.valueOf();
    condition['activity_date[lte]'] = end.valueOf();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/portfolio.service.ts